import { render, staticRenderFns } from "./editSysrole.vue?vue&type=template&id=3c0cf5e8&"
import script from "./editSysrole.vue?vue&type=script&lang=js&"
export * from "./editSysrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports